import React from 'react';
import { makeAutoObservable } from 'mobx';
import { observer } from 'mobx-react';
import {
	ActionButton,
	Icon,
	IContextualMenuProps,
	IIconProps,
	PrimaryButton,
	Spinner,
	Stack,
} from '@fluentui/react';
import API, { IUserConfigPackage } from '../../../API';
import { MSALConfigGen } from '../../../authConfig';

export interface IScopeCtrlProps {
	state: ScopeCtrlState;
}

class ScopeCtrl extends React.Component<IScopeCtrlProps, {}> {
	componentDidMount(): void {
		this.props.state.check();
	}

	render(): React.ReactNode {
		if (this.props.state.isChecking) {
			return (
				<ActionButton disabled={true}>
					<Spinner label={'Checking for consent...'} />
				</ActionButton>
			);
		}

		const addFriendIcon: IIconProps = { iconName: 'Accept' };


		const consentMenuProps: IContextualMenuProps = {
		items: [{
					key: 'currentUserOnly',
					text: 'Consent for current user only',
					onClick: () => {
						this.props.state.startConsent(false);
					},
					iconProps: { iconName: 'Lock' },
			}],
		};


		if (this.props.state.isApproved) {
			return <ActionButton iconProps={addFriendIcon}>Consented</ActionButton>;
		} else {
			return (
				<Stack horizontal>

					{this.props.state.isApp ? <ActionButton>Not Consented</ActionButton> :
						<PrimaryButton onClick={() => this.props.state.startConsent(true)} menuProps={consentMenuProps} split={true}>
							Consent
						</PrimaryButton>
					}
					<Icon
						iconName="Refresh"
						style={{ cursor: 'pointer', fontSize: 20, margin: 8 }}
						onClick={() => {
							this.props.state.check();
						}}
					/>
				</Stack>
			);
		}
	}
}

export default observer(ScopeCtrl);

export class ScopeCtrlState {
	public userConfig: IUserConfigPackage;
	public isSharePoint: boolean;
	public scope: string;

	public isChecking: boolean = true;
	description: string;
	isApp: boolean;
	public setIsChecking(val: boolean) {
		this.isChecking = val;
	}

	public isApproved: boolean = false;
	public setIsApproved(val: boolean) {
		this.isApproved = val;
	}

	constructor(
		isApp:boolean,
		userConfig: IUserConfigPackage,
		isSharePoint: boolean,
		scope: string,
		description: string,
	) {
		this.isApp = isApp;
		this.userConfig = userConfig;
		this.scope = scope;
		this.description = `${description} (${isSharePoint ? 'SharePoint' : 'Microsoft Graph'})`;
		this.isSharePoint = isSharePoint;

		makeAutoObservable(this);
	}

	public fullScope() : string {
		return this.isSharePoint
						? `${this.userConfig.tenantUrl}/${this.scope}`
						: `https://graph.microsoft.com/${this.scope}`;
	}

	public startConsent(wholeOrg:boolean) {
		let scope = this.fullScope();
		ScopeCtrlState.openPermissionUrl([scope], this.userConfig, this.isApp, wholeOrg);
	}

	public static openPermissionUrl(scopes:string[], userConfig:IUserConfigPackage, isApp:boolean, wholeOrg:boolean) {

		if(!wholeOrg) {
			scopes.push('openid');
		}

		let scopesStr = isApp ? '.default' : scopes.join(' ');
		let msalConfig = MSALConfigGen.getMsalConfig();
		let clientId = isApp ? msalConfig.auth.appClientId : msalConfig.auth.clientId;

		let singleUserUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${clientId}&response_type=id_token&redirect_uri=${encodeURIComponent(msalConfig.auth.redirectUri)}&scope=${encodeURIComponent(scopesStr)}&state=12345&nonce=12345`;
		let adminUrl = `https://login.microsoftonline.com/organizations/v2.0/adminconsent?client_id=${clientId}&scope=${scopesStr}`;

		let url = wholeOrg ? adminUrl : singleUserUrl;
		
		console.log(url);
		window.open(url, '_blank', 'popup,left=100,top=100,width=400,height=640');
	}

	public async check(): Promise<void> {
		this.setIsChecking(true);
		let token = await this.userConfig.getToken();
		let api = new API(token);
		let isApproved = await api.hasScope(this.scope, this.isSharePoint, this.isApp);
		this.setIsApproved(isApproved);
		this.setIsChecking(false);
	}
}
